type RegionId = string | number

export function createPortfolioRegionSelection(
    regions: { id: RegionId | null; name: string }[]
) {
    let allRegions = '__cromi_all_regions__'
    while (regions.some((region) => region.id === allRegions)) allRegions += '_'
    return {
        options: [
            { text: 'Все регионы', value: allRegions },
            ...regions
                .filter((region) => region.id !== null)
                .map((region) => ({
                    text: region.name,
                    value: region.id as RegionId,
                })),
        ],
        toUI: (value: RegionId | null | undefined) => value ?? allRegions,
        fromUI: (value: RegionId | null) =>
            value === allRegions ? null : value,
    }
}
